/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Popper, IconButton, Typography, Accordion, AccordionSummary, AccordionDetails, AccordionActions, LinearProgress, Tooltip, Avatar, Divider, Button, ClickAwayListener } from '@material-ui/core'
import { ExpandMore, Storage, Input, SettingsInputComposite, VpnKey, EditAttributes, ViewList, Language, ArrowRightAlt, Delete } from '@material-ui/icons';

import ai_or from '../../../../assets/ai_icon_or.png'
import ai_bl from '../../../../assets/ai_icon_bl.png'
import ai_gr from '../../../../assets/ai_icon_gr.png'

import { format } from 'date-fns'

import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import { zonedTimeToUtc } from 'date-fns-tz'
import Actions from '../../../../fluid/Actions/ActionFactory'

import {
  DateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'

import { allowedByOpop } from "./../../../Security/SecureCheck";

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => ({
    small_avatar : {
        width : theme.spacing(4),
        height : theme.spacing(4)
    }
})

class InformationUnit extends Component {
    state = {
        expanded : false,
        connection_expanded : false,
        data_expanded : false,
        connection_state : false,
        access_cred : false,
        adaptor_inputs : false,
        fields_in_scope : false,
        wv_map : false,
        delete_confirm : false,
        delete_confirm_ancorEl : null,
        start_date : null,
        data_transfer_err : false,
        iu_error : null,
        cur_time : new Date()
    }

    componentDidMount () {
        let access_cred = this.checkState('access_cred', this.props.iu.access_details, null)
        let adaptor_inputs = this.checkState('adaptor_inputs', this.props.iu.access_parameters, null)
        let fields_in_scope = this.checkState('fields_in_scope', this.props.iu.fields_in_scope, null)
        let wv_map = this.checkState('wv_map', this.props.iu.iu_world_view, null)
        this.setState({
            ...this.state,
            access_cred : access_cred,
            adaptor_inputs : adaptor_inputs,
            fields_in_scope : fields_in_scope,
            wv_map : wv_map,
            cur_time : new Date()
        }, () => {
            let state = this.state
            if (state.access_cred && state.adaptor_inputs && state.fields_in_scope && state.wv_map) {
                this.setState({
                    ...this.state,
                    connection_state : true
                })
            } else {
                this.setState({
                    ...this.state,
                    connection_state : false
                })
            }

            setInterval(() => {
                this.setState({cur_time : new Date()})
            }, 1000)
        })
    }

    checkState = (state_key, prop_obj,falsy_val) => {
        if (prop_obj === falsy_val) {
            return false
        } else {    
            return true
        }
    }

    renderSourceIcon = () => {
        console.log('Data Transfer Status :', this.props.iu.data_transfer_status)
        if (this.state.connection_state) {
            if (this.props.iu.data_transfer_status === 'Completed') {
                return (
                    <Fragment>
                        <Tooltip title = "Data Source">
                            <Storage style = {{margin : '5px', color : "#666666"}} size = 'small' />
                        </Tooltip>
                        <LinearProgress style = {{width : '140px'}} variant = 'determinate' value = {100} valueBuffer = {0}/>
                    </Fragment>
                )
            } else if (this.props.iu.data_transfer_status === "Aborted") {
                return (
                    <Fragment>
                        <Tooltip title = "Data Source">
                            <Storage style = {{margin : '5px', color : "#666666"}} size = 'small' />
                        </Tooltip>
                        <LinearProgress style = {{width : '140px'}} color = 'secondary' variant = 'determinate' value = {50}/>
                    </Fragment>
                )

            } else if (this.props.iu.data_transfer_status === 'InProgress') {
                return (
                    <Fragment>
                        <Tooltip title = "Data Source">
                            <Storage style = {{margin : '5px', color : "#666666"}} size = 'small' />
                        </Tooltip>
                        <LinearProgress style = {{width : '140px'}} color = 'primary' variant = 'indeterminate' value = {50} valueBuffer = {0}/>
                    </Fragment>
                )
            } else {
                return (
                    <Fragment>
                        <Tooltip title = "Data Source">
                            <Storage style = {{margin : '5px', color : "#666666"}} size = 'small' />
                        </Tooltip>
                        <LinearProgress style = {{width : '140px'}} variant = 'determinate' value = {0} valueBuffer = {0}/>
                    </Fragment>
                )
            }
        } else {
            return (
                <Fragment>
                    <Tooltip title = "Data Source">
                        <Storage style = {{margin : '5px', color : "#666666"}} size = 'small' />
                    </Tooltip>
                    <LinearProgress style = {{width : '140px'}} color = 'secondary' variant = 'buffer' value = {0} valueBuffer = {0}/>
                </Fragment>
            )
        }

    }

    renderSainpaseIcon = () => {
        if (this.state.connection_state) {
            if (this.props.iu.data_transfer_status === "Completed") {
                return (
                    <Tooltip title = "Sainapse">
                        <img style = {{width : '18px', margin : '5px'}} src = {ai_or}/>
                    </Tooltip>
                )
            } else if (this.props.iu.data_transfer_status === "Aborted") {
                return (
                    <Tooltip title = "Sainapse">
                        <img style = {{width : '18px', margin : '5px'}} src = {ai_gr}/>
                    </Tooltip>
                )
            } else if (this.props.iu.data_transfer_status === "InProgress") {
                return (
                    <Tooltip title = "Sainapse">
                        <img style = {{width : '18px', margin : '5px'}} src = {ai_or}/>
                    </Tooltip>
                )
            } else {
                return (
                    <Tooltip title = "Sainapse">
                        <img style = {{width : '18px', margin : '5px'}} src = {ai_or}/>
                    </Tooltip>
                )
            }
        } else {
            return (
                <Tooltip title = "Sainapse">
                    <img style = {{width : '18px', margin : '5px'}} src = {ai_gr}/>
                </Tooltip>
            )
        }
    }

    renderIUStatus = () => {
        return (
            <div>
                <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                    {this.renderSourceIcon()}
                    {this.renderSainpaseIcon()}
                </div>
            </div>
        )
    }

    renderConnectionStatus = () => {
        const { classes } = this.props
        return (
            <Accordion square elevation = {0} variant = 'outlined' style = {{backgroundColor : '#F0F0F0', width : '100%'}}>
                <AccordionSummary 
                    style = {{width : '100%'}}
                    expandIcon={<ExpandMore fontSize = 'small'/>}
                >
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                        <Typography style = {{flexGrow : 1}} variant = 'subtitle2'>Adaptor Connection Status</Typography>
                        <Avatar className = {classes.small_avatar} style = {{backgroundColor : this.state.connection_state ? "#4caf50" : "#f44336"}}>
                            <SettingsInputComposite fontSize = 'small' style = {{color : '#FFFFFF'}}/>
                        </Avatar>
                    </div>
                </AccordionSummary>
                <AccordionDetails style = {{backgroundColor : '#FFFFFF'}}>
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent: 'center'}}>
                        {this.renderConnectionLink()}
                    </div>
                </AccordionDetails>
            </Accordion>
        )
    }

    renderConnectionLink = () => {
        return (
            <div style = {{width : '70%', display : 'flex', flexDirection : 'row', alignItems : 'center', marginTop : '10px'}}>
                <Tooltip title = 'Access Credentials'>
                    <VpnKey fontSize = 'small' style = {{margin : '5px', color : this.state.access_cred ? "#4caf50" : "#f44336"}}/>
                </Tooltip>
                <LinearProgress 
                    style = {{flexGrow : 1, height : '3px'}} 
                    variant = {this.state.access_cred ? 'determinate' : 'buffer'} 
                    value = {this.state.access_cred ? 100 : 0}  
                    valueBuffer = {this.state.access_cred ? 100 : 0}  
                    color = {this.state.access_cred ? 'primary': 'secondary'} 
                />
                <Tooltip title = 'Adaptor Parameters'>
                    <EditAttributes fontSize = 'small' style = {{margin : '5px', color : this.state.adaptor_inputs ? "#4caf50" : "#f44336"}}/>
                </Tooltip>
                <LinearProgress 
                    style = {{flexGrow : 1, height : '3px'}} 
                    variant = {this.state.adaptor_inputs ? 'determinate' : 'buffer'} 
                    value = {this.state.adaptor_inputs ? 100 : 0}  
                    valueBuffer = {this.state.adaptor_inputs ? 100 : 0}  
                    color = {this.state.adaptor_inputs ? 'primary': 'secondary'}
                />
                <Tooltip title = 'Fields In Scope'>
                    <ViewList fontSize = 'small' style = {{margin : '5px', color : this.state.fields_in_scope ? "#4caf50" : "#f44336"}}/>
                </Tooltip>
                <LinearProgress 
                    style = {{flexGrow : 1, height : '3px'}} 
                    variant = {this.state.fields_in_scope ? 'determinate' : 'buffer'} 
                    value = {this.state.fields_in_scope ? 100 : 0}  
                    valueBuffer = {this.state.fields_in_scope ? 100 : 0}  
                    color = {this.state.fields_in_scope ? 'primary': 'secondary'}
                />
                <Tooltip title = 'World View Map'>
                    <Language fontSize = 'small' style = {{margin : '5px', color : this.state.wv_map ? "#4caf50" : "#f44336"}}/>
                </Tooltip>
                <LinearProgress 
                    style = {{flexGrow : 1, height : '3px'}} 
                    variant = {this.state.wv_map ? 'determinate' : 'buffer'} 
                    value = {this.state.wv_map ? 100 : 0}  
                    valueBuffer = {this.state.wv_map ? 100 : 0}  
                    color = {this.state.wv_map ? 'primary': 'secondary'}
                />
                <Tooltip title = "Sainapse">
                    <img style = {{width : '18px', margin : '5px'}} src = {this.state.connection_state ? ai_or : ai_gr}/>
                </Tooltip>
            </div>
        )
    }

    renderDataTransfer = () => {
        const { classes } = this.props
        return (
            <Accordion disabled = {this.state.connection_state || this.props.iu.config_type === "Trainable" ? false : true} square elevation = {0} variant = 'outlined' 
                style = {{backgroundColor : '#F0F0F0', width : '100%'}}>
                <AccordionSummary 
                    style = {{width : '100%'}}
                    expandIcon={<ExpandMore fontSize = 'small'/>}
                >
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                        <Typography style = {{flexGrow : 1}} variant = 'subtitle2'>Data Transfer</Typography>
                        {/* {this.props.iu.config_type === 'Trainable' ? this.renderIUStatus() : <Typography variant = 'caption' color = 'textSecondary'>Non Trainable</Typography>} */}
                    </div>
                </AccordionSummary>
                {this.props.iu.config_type === 'Trainable' ? <AccordionDetails style = {{backgroundColor : '#FFFFFF', padding : 0}}>
                    <div style = {{width : '100%'}}>
                        {this.renderClear()}
                        {this.props.iu.data_transfer_status_object.length > 0 && this.getLastSuccessfulDataTransferTime() !== null ? this.renderIncremental() : null}
                        {this.props.iu.data_transfer_status === 'PartiallyCompleted' ? this.renderContinueDataTransfer() : null}
                    </div>
                </AccordionDetails> : null}
            </Accordion>
        )
    }

    updateStartDate = (date) => {
        this.setState({...this.state, start_date : date})
    }

    transferData = (type, entity, entity_name) => {
        let transfer_object = this.generateTransferObject(type, entity, entity_name)

        if (type === 'Clean') {
            transfer_object = this.cleanTransfer(transfer_object, )
        } else if (type === 'Incremental') {
            transfer_object = this.incrementalTransfer(transfer_object, entity, entity_name)
        } else if(type === 'Restart') {
            transfer_object = this.continueTrasnfer(transfer_object, )
        }

        Actions("http_request", {
            url: "/sainapse/train/data",
            method: "post",
            data: [transfer_object]
        }).then(res => {
            this.props.refresh()
        }).catch(err => {
            this.props.refresh()
        })

        // this.setState({...this.state, open : false}, () => {
        //     this.props.transfer_data(transfer_object, entity, entity_name)
        // })
    }

    generateTransferObject = (type) => {
        let transfer_object = {
            ic_name : this.props.ic.name,
            iu_names : [this.props.iu.name],
            time_filters : [],
            type : null
        }
        return transfer_object
    }

    continueTrasnfer = (transfer_object) => {
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        console.log("Current Time Zone : ", timezone )

        let time_filter = {
            start_time : zonedTimeToUtc(format(new Date(this.state.start_date),'yyyy-MM-dd HH:mm:ss'), timezone).toISOString(),
            end_time : zonedTimeToUtc(format(this.state.cur_time,'yyyy-MM-dd HH:mm:ss'), timezone).toISOString()
        }

        transfer_object.time_filters.push(time_filter)
        transfer_object.type = "Restart"

        return transfer_object
    }

    cleanTransfer = (transfer_object) => {
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        console.log("Current Time Zone : ", timezone )

        let time_filter = {
            start_time : zonedTimeToUtc(format(new Date(this.state.start_date),'yyyy-MM-dd HH:mm:ss'), timezone).toISOString(),
            end_time : zonedTimeToUtc(format(this.state.cur_time,'yyyy-MM-dd HH:mm:ss'), timezone).toISOString()
        }

        transfer_object.time_filters.push(time_filter)
        transfer_object.type = "Clean"

        return transfer_object
    }

    incrementalTransfer = (transfer_object) => {
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        console.log("Current Time Zone : ", timezone )

        let time_filter = {
            start_time : null,
            end_time : zonedTimeToUtc(format(new Date(),'yyyy-MM-dd HH:mm:ss'), timezone).toISOString()
        }

        let iu_object = this.props.ic.information_units.find(iu => iu.name === this.props.iu.name)
        time_filter.start_time = iu_object.last_data_transfer_date

        // if (entity === "ic") {
        //     time_filter.start_time = this.props.ic.last_data_transfer_date
        // } else if (entity === "iu") {
        //     let iu_object = this.props.ic.information_units.find(iu => iu.name === entity_name)
        //     time_filter.start_time = iu_object.last_data_transfer_date
        // }
        transfer_object.type = "Incremental"

        return transfer_object
    }

    renderClear = () => {
        return (
            <Accordion square disabled = {!this.state.connection_state}>
                <AccordionSummary
                    style = {{borderBottom : '1px solid rgba(0,0,0,0.12)'}}
                    expandIcon={<ExpandMore />}
                >
                    <Typography variant = 'subtitle2' color = 'primary'>Fresh Import</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant = 'body2'>This action will delete all previously transferred data and starts a fresh import. Use this action to import data for the first time.</Typography>
                </AccordionDetails>
                <div style = {{width : '100%', padding : '20px', display : 'flex', flexDirection : 'row', justifyContent : 'center'}}>
                    <Typography variant = 'body2' color = 'textSecondary'>Select the date and time from when the data has to be considered.</Typography>
                </div>
                <div style = {{width : '100%', padding : '20px',display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <div style = {{flexGrow : 1, padding : '10px'}}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DateTimePicker
                                fullWidth
                                disableFuture
                                label = "Start Date"
                                value={this.state.start_date}
                                onChange={(value) => {
                                    this.updateStartDate(value)
                                }}
                                helperText="Choose Start Date and Time"
                                format="yyyy/MM/dd HH:mm"
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                    <div>
                        <ArrowRightAlt color = 'primary'/>
                    </div>
                    <div style = {{flexGrow : 1, padding : '10px', wordWrap : 'break-word', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                        <div>
                            <Typography style = {{display : 'block'}} variant = 'subtitle2'>Now</Typography>
                            <Typography variant = 'caption' color ='textSecondary'>{format(this.state.cur_time, "EEE LLL do yyyy 'at' HH:mm:ss zzz")}</Typography>
                        </div>
                    </div>
                </div>
                <Divider/>
                <AccordionActions>
                    <Button 
                        variant = 'contained'
                        color = 'primary'
                        endIcon = {<ArrowRightAlt/>}
                        size = 'small'
                        disabled = {this.state.clear_start_date !== null ? false : true}
                        onClick = {() => this.transferData('Clean')}
                    >
                        Initiate Transfer
                    </Button>
                </AccordionActions>
            </Accordion>
        )
    }

    getLastSuccessfulDataTransferTime = () => {
        let successful_data_transfer_objects = this.props.iu.data_transfer_status_object.filter(item => item.status === 'Completed')
        if (successful_data_transfer_objects.length > 0) {
            let desc_sorted_success_objects = successful_data_transfer_objects.sort((a,b) => new Date(b.start_time) - new Date(a.start_time))
            let last_success_start_time = desc_sorted_success_objects[0].start_time
            return last_success_start_time
        } else {
            return null
        }
    }

    renderContinueDataTransfer = () => {
        return (
            <Accordion square disabled = {!this.state.connection_state}>
                    <AccordionSummary style = {{borderBottom : '1px solid rgba(0,0,0,0.12)'}}
                    expandIcon={<ExpandMore />} >
                        <Typography variant = 'subtitle2' color = 'primary'>Continue data transfer</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                    <Typography variant = 'body2'>This action will continue the data transfer and will not transfer already processed data. Use this action if you see partially completed status</Typography>
                </AccordionDetails>
                <div style = {{width : '100%', padding : '20px', display : 'flex', flexDirection : 'row', justifyContent : 'center'}}>
                    <Typography variant = 'body2' color = 'textSecondary'>Select the date and time from when the data has to be considered.</Typography>
                </div>
                <div style = {{width : '100%', padding : '20px',display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <div style = {{flexGrow : 1, padding : '10px'}}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DateTimePicker
                                fullWidth
                                disableFuture
                                label = "Start Date"
                                value={this.state.start_date}
                                onChange={(value) => {
                                    this.updateStartDate(value)
                                }}
                                helperText="Choose Start Date and Time"
                                format="yyyy/MM/dd HH:mm"
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                    <div>
                        <ArrowRightAlt color = 'primary'/>
                    </div>
                    <div style = {{flexGrow : 1, padding : '10px', wordWrap : 'break-word', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                        <div>
                            <Typography style = {{display : 'block'}} variant = 'subtitle2'>Now</Typography>
                            <Typography variant = 'caption' color ='textSecondary'>{format(this.state.cur_time, "EEE LLL do yyyy 'at' HH:mm:ss zzz")}</Typography>
                        </div>
                    </div>
                </div>
                <Divider/>
                <AccordionActions>
                    <Button 
                        variant = 'contained'
                        color = 'primary'
                        endIcon = {<ArrowRightAlt/>}
                        size = 'small'
                        disabled = {this.state.clear_start_date !== null ? false : true}
                        onClick = {() => this.transferData('Restart')}
                    >
                        Continue Transfer
                    </Button>
                </AccordionActions>
            </Accordion>
        )
    }

    renderIncremental = () => {
        return (
            <Accordion square disabled = {this.state.connection_state === false ? true : false}>
                <AccordionSummary
                    style = {{borderBottom : '1px solid rgba(0,0,0,0.12)'}}
                    expandIcon={<ExpandMore />}
                >
                    <Typography variant = 'subtitle2' color = 'primary'>Import latest data</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant = 'body2'>This action will import all the data from the last data transfer date.</Typography>
                </AccordionDetails>
                <div style = {{width : '100%', padding : '20px',display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <div style = {{flexGrow : 1, padding : '10px', wordWrap : 'break-word', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                        <div>
                            <Typography style = {{display : 'block'}} variant = 'subtitle2'>Last Transfer Date</Typography>
                            <Typography variant = 'caption' color ='textSecondary'>{format(new Date(this.getLastSuccessfulDataTransferTime()), "EEE LLL do yyyy 'at' HH:mm:ss zzz")}</Typography>
                        </div>
                    </div>
                    <div>
                        <ArrowRightAlt color = 'primary'/>
                    </div>
                    <div style = {{flexGrow : 1, padding : '10px', wordWrap : 'break-word', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                        <div>
                            <Typography style = {{display : 'block'}} variant = 'subtitle2'>Now</Typography>
                            <Typography variant = 'caption' color ='textSecondary'>{format(this.state.cur_time, "EEE LLL do yyyy 'at' HH:mm:ss zzz")}</Typography>
                        </div>
                    </div>
                </div>
                <Divider/>
                <AccordionActions>
                    <Button 
                        variant = 'contained'
                        color = 'primary'
                        endIcon = {<ArrowRightAlt/>}
                        size = 'small'
                        onClick = {() => this.transferData('Incremental')}
                    >
                        Initiate Transfer
                    </Button>
                </AccordionActions>
            </Accordion>
        )
    }

    toggleDeleteConfirm = (event) => {
        this.setState({
            ...this.state,
            delete_confirm : !this.state.delete_confirm,
            delete_confirm_ancorEl : event.currentTarget
        })
    }

    closeConfirmDelete = () => {
        this.setState({
            ...this.state,
            delete_confirm : false,
            delete_confirm_ancorEl : null
        })
    }

    deleteIU = () => {
        this.setState({...this.state, delete_confirm : false, iu_error : null}, () => {
            Actions('http_request', {
                url : "/sainapse/information_channel/" + this.props.ic.name + "/information_unit/" + this.props.iu.name,
                method : "delete",
                data : {}
            }).then(res => {
                this.props.refresh()
            }).catch(err => {
                let error = err.response.data
                this.setState({...this.state, iu_error : error.message})
            })
        })
    }

    getDisabledDeleteIU  = (icName, iuName) => {
        return !allowedByOpop({
          operation : "/sainapse/information_channel/{ic_name}/information_unit/{name}",
          method : "DELETE",
          operands : [
            {
              attrName: "ic_name",
              value : icName
            },
            {
              attrName: "name",
              value : iuName
        }]
        })
      };

    confirmDelete = () => {
        return (
            <Popper
                key = {"training-trigger"}
                open={this.state.delete_confirm}
                anchorEl={this.state.delete_confirm_ancorEl}
                placement="bottom"
                modifiers={{
                    flip: {
                        enabled: true,
                    },
                    preventOverflow: {
                        enabled: false,
                        boundariesElement: 'scrollParent',
                    },
                    arrow: {
                        enabled: true,
                        element: this.state.arrowRef,
                    },
                }}
            >
                <ClickAwayListener onClickAway = {this.closeConfirmDelete}>
                    <Paper style = {{padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                        <Typography variant = 'body2'>Confirm Delete ?</Typography>
                        <IconButton style = {{marginLeft : '15px'}} color = 'secondary' size = 'small'>
                            <Delete onClick = {this.deleteIU}/>
                        </IconButton>
                    </Paper>
                </ClickAwayListener>
            </Popper>
        )
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{width : '100%', padding: '5px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                    <Accordion style = {{borderLeft : '3px solid #2296f3'}} square variant = 'outlined'>
                        <AccordionSummary
                            style = {{backgroundColor : '#FAFBFC'}}
                            expandIcon={<ExpandMore fontSize = 'small'/>}
                        >
                            <div style = {{width : '100%'}}>
                                <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                    <div style = {{flexGrow : 1, display : 'flex', flexDirection : 'row', alignItems: 'center'}}>
                                        <Tooltip title = 'Information Unit'>
                                            <Avatar style = {{width : '35px', height : '35px', backgroundColor : "#2296f3", marginRight : '5px'}}>
                                                {/* <Typography variant = 'button'>IU</Typography> */}
                                                <Input fontSize = 'small'/>
                                            </Avatar>
                                        </Tooltip>
                                        <div>
                                            <Typography variant = 'subtitle2' color = 'primary'>{this.props.iu.name}</Typography>
                                            <Typography style = {{fontSize : '11px'}} variant = 'body2' color = 'textSecondary'>{this.props.iu.type}</Typography>
                                        </div>
                                        {/* <Typography variant = 'caption' color = 'textSecondary'>Information Unit</Typography> */}
                                    </div>
                                    <div>
                                        {/* {this.props.iu.config_type === 'Trainable' ? <Typography style = {{marginLeft : '5px'}} variant = 'caption' color = 'textSecondary' align = 'center'>{'Data Transfer ' + this.props.iu.data_transfer_status}</Typography> : null} */}
                                        <Tooltip title = {this.props.iu.config_type === 'Trainable' ? 'Data Transfer ' + this.props.iu.data_transfer_status : 'Non Trainable'}>
                                            {this.props.iu.config_type === 'Trainable' ? this.renderIUStatus() : <Typography variant = 'caption' color = 'textSecondary'>Non Trainable</Typography>}
                                        </Tooltip>
                                    </div>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails style = {{backgroundColor : '#FAFBFC', padding : 0}}>
                            <div style = {{width : '100%', padding : '5px'}}>
                                <div style = {{width : '100%', padding : '10px'}}>
                                    <Typography variant = 'caption'>{this.props.iu.data_transfer_status_object.length > 0 ? this.props.iu.data_transfer_status_object.sort((a,b) => new Date(b.start_time) - new Date(a.start_time))[0].message : null}</Typography>
                                </div>
                                {this.props.show_connection ? this.renderConnectionStatus() : null}
                                {this.props.show_data_transfer ? this.renderDataTransfer() : null}
                            </div>
                        </AccordionDetails>
                        {this.props.show_actions ? 
                            <AccordionActions>
                                {this.state.iu_error !== null && <Typography variant = 'caption' color = "secondary">{this.state.iu_error}</Typography>}
                                    <Button
                                        variant = 'outlined'
                                        color = 'secondary'
                                        endIcon = {<Delete/>}
                                        size = 'small'
                                        onClick = {this.toggleDeleteConfirm}
                                        style={{ color: !this.getDisabledDeleteIU(this.props.ic.name, this.props.iu.name) ? "#f44336": "rgb(0,0,0,0.3)", marginRight: "0px" }}
                                        disabled = {this.getDisabledDeleteIU(this.props.ic.name, this.props.iu.name)} 
                                    >
                                        {this.props.iu.name}
                                    </Button>
                            </AccordionActions> : null}
                    </Accordion>
                </div>
                {this.confirmDelete()}
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(InformationUnit);